import { Record } from 'immutable';
import { TaxEntity } from './TaxEntity';

const TaxRequestRecord = Record({
  supplyDate: null,
  buyer: null,
  supplier: null,
  billedTo: null
});

export class TaxRequest extends TaxRequestRecord {
  supplyDate: string;
  buyer: TaxEntity;
  supplier: TaxEntity;
  billedTo: TaxEntity;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/TaxRequest.ts